// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
    width: 100%;
    display: flex;
    overflow: auto;
    min-height: 100vh;
    align-items: center;
    flex-direction: column;
}
.absence-list {
    width: 100%;
    display: flex;
    overflow: auto;
    min-height: 100vh;
    align-items: center;
    flex-direction: column;
}
.home-header {
    width: 100%;
    display: flex;
    z-index: 100;
    position: sticky;
    top: 0;
    align-items: center;
    flex-direction: column;
    background-color: var(--dl-color-custom-secondary);
}

.mobile-add-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0;
}

.add-btn-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: var(--dl-color-custom-primary);
    text-decoration: none;
    font-size: 11px;
}

.add-btn-header svg {
    color: white;
    font-size: 20px;
}

.home-desktop-menu {
    flex: 1 1;
    display: flex;
    justify-content: space-between;
}
.home-links {
    flex: 1 1;
    border: none;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
}
.home-buttons {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
}
.home-login {
    text-align: right;
    display: contents;
    cursor: pointer;
}
.home-burger-menu {
    display: none;
}
.home-icon {
    width: var(--dl-size-size-xsmall);
    cursor: pointer;
    height: var(--dl-size-size-xsmall);
}
.home-mobile-menu1 {
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100vh;
    display: none;
    padding: 32px;
    z-index: 100;
    position: absolute;
    flex-direction: column;
    justify-content: space-between;
}
.home-nav {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}
.home-top {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: var(--dl-space-space-threeunits);
    justify-content: space-between;
}
.home-close-menu {
    display: flex;
    align-items: center;
    justify-content: center;
}
.home-icon02 {
    width: var(--dl-size-size-xsmall);
    cursor: pointer;
    height: var(--dl-size-size-xsmall);
}
.home-links1 {
    flex: 0 0 auto;
    display: flex;
    align-self: flex-start;
    align-items: flex-start;
    flex-direction: column;
}
.home-nav12 {
    margin-bottom: var(--dl-space-space-unit);
}
.home-nav22 {
    margin-bottom: var(--dl-space-space-unit);
}
.home-nav32 {
    margin-bottom: var(--dl-space-space-unit);
}
.home-nav42 {
    margin-bottom: var(--dl-space-space-unit);
}
.home-buttons1 {
    display: flex;
    margin-top: var(--dl-space-space-unit);
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
}
.home-icon04 {
    width: var(--dl-size-size-xsmall);
    height: var(--dl-size-size-xsmall);
    margin-right: var(--dl-space-space-twounits);
}
.home-icon06 {
    width: var(--dl-size-size-xsmall);
    height: var(--dl-size-size-xsmall);
    margin-right: var(--dl-space-space-twounits);
}
.home-icon08 {
    width: var(--dl-size-size-xsmall);
    height: var(--dl-size-size-xsmall);
}
.home-hero {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
.home-container1 {
    gap: var(--dl-space-space-oneandhalfunits);
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
}
.home-hero-heading {
    max-width: 800px;
    text-align: center;
}
.home-hero-sub-heading {
    font-size: 18px;
    text-align: center;
}
.home-btn-group {
    gap: var(--dl-space-space-oneandhalfunits);
    display: flex;
    align-items: center;
    flex-direction: row;
}
.home-features {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home-features1 {
    gap: var(--dl-space-space-threeunits);
    width: 100%;
    display: flex;
    max-width: var(--dl-size-size-maxwidth);
    align-items: center;
    padding-top: var(--dl-space-space-fourunits);
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
    flex-direction: column;
    padding-bottom: var(--dl-space-space-fourunits);
    justify-content: flex-start;
}
.home-container2 {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
}
.home-features-heading {
    margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-features-sub-heading {
    font-size: 18px;
    text-align: center;
}
.home-container3 {
    width: 100%;
    grid-gap: var(--dl-grid-gap-space);
    grid-template-columns: 1fr 1fr;
}

.absence-list .home-container3 {
  display: grid;
}

.home-pricing {
    flex: 0 0 auto;
    width: 100%;
    border: 2px dashed rgba(120, 120, 120, 0.4);
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home-banner {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home-banner-heading {
    text-align: center;
}
.home-banner-sub-heading {
    max-width: var(--dl-size-size-maxwidth);
    margin-top: var(--dl-space-space-twounits);
    text-align: center;
    margin-bottom: var(--dl-space-space-twounits);
}
.home-faq {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home-faq1 {
    gap: var(--dl-space-space-twounits);
    width: 100%;
    display: flex;
    max-width: var(--dl-size-size-maxwidth);
    align-items: flex-start;
    padding-top: var(--dl-space-space-fourunits);
    padding-left: var(--dl-space-space-threeunits);
    padding-right: var(--dl-space-space-threeunits);
    flex-direction: row;
    padding-bottom: var(--dl-space-space-fourunits);
}
.home-container4 {
    display: flex;
    max-width: 35%;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
}
.home-text51 {
    margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.home-text52 {
    text-align: left;
}
.home-container5 {
    gap: var(--dl-space-space-oneandhalfunits);
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}
.home-footer {
    flex: 0 0 auto;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}
.home-container6 {
    gap: var(--dl-space-space-unit);
    display: flex;
    max-width: var(--dl-size-size-maxwidth);
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
}
.home-nav1 {
    flex: 0 0 auto;
    border: 2px dashed rgba(120, 120, 120, 0.4);
    display: flex;
    margin-top: 0px;
    align-items: center;
    flex-direction: row;
}
.home-separator {
    flex: 0 0 auto;
    width: 100%;
    height: 0px;
    display: flex;
    margin-top: var(--dl-space-space-twounits);
    align-items: flex-start;
    margin-left: 0px;
    border-color: var(--dl-color-gray-900);
    border-style: solid;
    border-width: 1px;
    margin-right: 0px;
    margin-bottom: var(--dl-space-space-twounits);
    flex-direction: row;
    border-top-width: 0px;
    border-left-width: 0px;
    border-right-width: 0px;
}
.home-container7 {
    flex: 0 0 auto;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
}
.home-icon-group1 {
    border: 2px dashed rgba(120, 120, 120, 0.4);
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
}
@media (max-width: 991px) {
    .home-hero1 {
        flex-direction: column;
    }
    .home-container1 {
        align-items: center;
        margin-right: 0px;
        margin-bottom: var(--dl-space-space-twounits);
        padding-right: 0px;
    }
    .home-hero-heading {
        text-align: center;
    }
    .home-text {
        text-align: center;
    }
    .home-hero-sub-heading {
        text-align: center;
        padding-left: var(--dl-space-space-threeunits);
        padding-right: var(--dl-space-space-threeunits);
    }
    .home-features-sub-heading {
        text-align: center;
        padding-left: var(--dl-space-space-threeunits);
        padding-right: var(--dl-space-space-threeunits);
    }
    .home-banner-sub-heading {
        max-width: 100%;
    }
    .home-text52 {
        text-align: center;
        padding-left: var(--dl-space-space-threeunits);
        padding-right: var(--dl-space-space-threeunits);
    }
}
@media (max-width: 767px) {
    .home-navbar-interactive {
        padding-left: var(--dl-space-space-twounits);
        padding-right: var(--dl-space-space-twounits);
    }
    .home-desktop-menu {
        display: none;
    }
    .home-burger-menu {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .home-nav12 {
        margin-bottom: var(--dl-space-space-unit);
    }
    .home-nav22 {
        margin-bottom: var(--dl-space-space-unit);
    }
    .home-nav32 {
        margin-bottom: var(--dl-space-space-unit);
    }
    .home-nav42 {
        margin-bottom: var(--dl-space-space-unit);
    }
    .home-hero1 {
        padding-left: var(--dl-space-space-twounits);
        padding-right: var(--dl-space-space-twounits);
    }
    .home-hero-sub-heading {
        padding-left: var(--dl-space-space-unit);
        padding-right: var(--dl-space-space-unit);
    }
    .home-features1 {
        padding-left: var(--dl-space-space-twounits);
        padding-right: var(--dl-space-space-twounits);
    }
    .home-features-sub-heading {
        padding-left: var(--dl-space-space-unit);
        padding-right: var(--dl-space-space-unit);
    }
    .home-container3 {
        grid-template-columns: 1fr;
    }
    .home-banner1 {
        padding-left: var(--dl-space-space-twounits);
        padding-right: var(--dl-space-space-twounits);
    }
    .home-banner-sub-heading {
        padding-left: var(--dl-space-space-unit);
        padding-right: var(--dl-space-space-unit);
    }
    .home-faq1 {
        flex-direction: column;
    }
    .home-container4 {
        max-width: 100%;
        align-self: center;
        align-items: center;
        justify-content: center;
    }
    .home-text52 {
        padding-left: var(--dl-space-space-unit);
        padding-right: var(--dl-space-space-unit);
    }
    .home-footer1 {
        padding-left: var(--dl-space-space-twounits);
        padding-right: var(--dl-space-space-twounits);
    }
    .home-separator {
        margin-top: var(--dl-space-space-oneandhalfunits);
        margin-left: 0px;
        margin-right: 0px;
        margin-bottom: var(--dl-space-space-oneandhalfunits);
    }
    .home-container7 {
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
    }
    .home-text56 {
        margin-bottom: var(--dl-space-space-oneandhalfunits);
    }
}
@media (max-width: 479px) {
    .home-navbar-interactive {
        padding: var(--dl-space-space-unit);
    }
    .home-mobile-menu1 {
        padding: 16px;
    }
    .home-hero1 {
        padding-top: var(--dl-space-space-twounits);
        padding-left: var(--dl-space-space-unit);
        padding-right: var(--dl-space-space-unit);
        padding-bottom: var(--dl-space-space-twounits);
    }
    .home-container1 {
        margin-bottom: var(--dl-space-space-unit);
    }
    .home-btn-group {
        flex-direction: column;
    }
    .home-features1 {
        padding-top: var(--dl-space-space-twounits);
        padding-left: var(--dl-space-space-unit);
        padding-right: var(--dl-space-space-unit);
        padding-bottom: var(--dl-space-space-twounits);
    }
    .home-banner1 {
        padding-top: var(--dl-space-space-twounits);
        padding-left: var(--dl-space-space-unit);
        padding-right: var(--dl-space-space-unit);
        padding-bottom: var(--dl-space-space-twounits);
    }
    .home-footer1 {
        padding: var(--dl-space-space-unit);
    }
    .home-separator {
        margin-top: var(--dl-space-space-oneandhalfunits);
        margin-bottom: var(--dl-space-space-oneandhalfunits);
    }
    .home-container7 {
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
    }
    .home-text56 {
        text-align: center;
        margin-bottom: var(--dl-space-space-oneandhalfunits);
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/home.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,iCAAiC;IACjC,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,aAAa;IACb,aAAa;IACb,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,iCAAiC;IACjC,eAAe;IACf,kCAAkC;AACtC;AACA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,4CAA4C;AAChD;AACA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,4CAA4C;AAChD;AACA;IACI,iCAAiC;IACjC,kCAAkC;AACtC;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,mBAAmB;IACnB,4CAA4C;IAC5C,8CAA8C;IAC9C,+CAA+C;IAC/C,sBAAsB;IACtB,+CAA+C;IAC/C,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,oDAAoD;AACxD;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uCAAuC;IACvC,0CAA0C;IAC1C,kBAAkB;IAClB,6CAA6C;AACjD;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mCAAmC;IACnC,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,uBAAuB;IACvB,4CAA4C;IAC5C,8CAA8C;IAC9C,+CAA+C;IAC/C,mBAAmB;IACnB,+CAA+C;AACnD;AACA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,oDAAoD;AACxD;AACA;IACI,gBAAgB;AACpB;AACA;IACI,0CAA0C;IAC1C,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,+BAA+B;IAC/B,aAAa;IACb,uCAAuC;IACvC,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,2CAA2C;IAC3C,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,aAAa;IACb,0CAA0C;IAC1C,uBAAuB;IACvB,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,6CAA6C;IAC7C,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,6CAA6C;QAC7C,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,8CAA8C;QAC9C,+CAA+C;IACnD;IACA;QACI,kBAAkB;QAClB,8CAA8C;QAC9C,+CAA+C;IACnD;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,8CAA8C;QAC9C,+CAA+C;IACnD;AACJ;AACA;IACI;QACI,4CAA4C;QAC5C,6CAA6C;IACjD;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,4CAA4C;QAC5C,6CAA6C;IACjD;IACA;QACI,wCAAwC;QACxC,yCAAyC;IAC7C;IACA;QACI,4CAA4C;QAC5C,6CAA6C;IACjD;IACA;QACI,wCAAwC;QACxC,yCAAyC;IAC7C;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,4CAA4C;QAC5C,6CAA6C;IACjD;IACA;QACI,wCAAwC;QACxC,yCAAyC;IAC7C;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,wCAAwC;QACxC,yCAAyC;IAC7C;IACA;QACI,4CAA4C;QAC5C,6CAA6C;IACjD;IACA;QACI,iDAAiD;QACjD,gBAAgB;QAChB,iBAAiB;QACjB,oDAAoD;IACxD;IACA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,8BAA8B;IAClC;IACA;QACI,oDAAoD;IACxD;AACJ;AACA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,aAAa;IACjB;IACA;QACI,2CAA2C;QAC3C,wCAAwC;QACxC,yCAAyC;QACzC,8CAA8C;IAClD;IACA;QACI,yCAAyC;IAC7C;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,2CAA2C;QAC3C,wCAAwC;QACxC,yCAAyC;QACzC,8CAA8C;IAClD;IACA;QACI,2CAA2C;QAC3C,wCAAwC;QACxC,yCAAyC;QACzC,8CAA8C;IAClD;IACA;QACI,mCAAmC;IACvC;IACA;QACI,iDAAiD;QACjD,oDAAoD;IACxD;IACA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,8BAA8B;IAClC;IACA;QACI,kBAAkB;QAClB,oDAAoD;IACxD;AACJ","sourcesContent":[".home-container {\r\n    width: 100%;\r\n    display: flex;\r\n    overflow: auto;\r\n    min-height: 100vh;\r\n    align-items: center;\r\n    flex-direction: column;\r\n}\r\n.absence-list {\r\n    width: 100%;\r\n    display: flex;\r\n    overflow: auto;\r\n    min-height: 100vh;\r\n    align-items: center;\r\n    flex-direction: column;\r\n}\r\n.home-header {\r\n    width: 100%;\r\n    display: flex;\r\n    z-index: 100;\r\n    position: sticky;\r\n    top: 0;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    background-color: var(--dl-color-custom-secondary);\r\n}\r\n\r\n.mobile-add-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-left: 0;\r\n}\r\n\r\n.add-btn-header {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    background-color: var(--dl-color-custom-primary);\r\n    text-decoration: none;\r\n    font-size: 11px;\r\n}\r\n\r\n.add-btn-header svg {\r\n    color: white;\r\n    font-size: 20px;\r\n}\r\n\r\n.home-desktop-menu {\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.home-links {\r\n    flex: 1;\r\n    border: none;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n}\r\n.home-buttons {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n.home-login {\r\n    text-align: right;\r\n    display: contents;\r\n    cursor: pointer;\r\n}\r\n.home-burger-menu {\r\n    display: none;\r\n}\r\n.home-icon {\r\n    width: var(--dl-size-size-xsmall);\r\n    cursor: pointer;\r\n    height: var(--dl-size-size-xsmall);\r\n}\r\n.home-mobile-menu1 {\r\n    top: 0px;\r\n    left: 0px;\r\n    width: 100%;\r\n    height: 100vh;\r\n    display: none;\r\n    padding: 32px;\r\n    z-index: 100;\r\n    position: absolute;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n}\r\n.home-nav {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n}\r\n.home-top {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: var(--dl-space-space-threeunits);\r\n    justify-content: space-between;\r\n}\r\n.home-close-menu {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.home-icon02 {\r\n    width: var(--dl-size-size-xsmall);\r\n    cursor: pointer;\r\n    height: var(--dl-size-size-xsmall);\r\n}\r\n.home-links1 {\r\n    flex: 0 0 auto;\r\n    display: flex;\r\n    align-self: flex-start;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n}\r\n.home-nav12 {\r\n    margin-bottom: var(--dl-space-space-unit);\r\n}\r\n.home-nav22 {\r\n    margin-bottom: var(--dl-space-space-unit);\r\n}\r\n.home-nav32 {\r\n    margin-bottom: var(--dl-space-space-unit);\r\n}\r\n.home-nav42 {\r\n    margin-bottom: var(--dl-space-space-unit);\r\n}\r\n.home-buttons1 {\r\n    display: flex;\r\n    margin-top: var(--dl-space-space-unit);\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n.home-icon04 {\r\n    width: var(--dl-size-size-xsmall);\r\n    height: var(--dl-size-size-xsmall);\r\n    margin-right: var(--dl-space-space-twounits);\r\n}\r\n.home-icon06 {\r\n    width: var(--dl-size-size-xsmall);\r\n    height: var(--dl-size-size-xsmall);\r\n    margin-right: var(--dl-space-space-twounits);\r\n}\r\n.home-icon08 {\r\n    width: var(--dl-size-size-xsmall);\r\n    height: var(--dl-size-size-xsmall);\r\n}\r\n.home-hero {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n}\r\n.home-container1 {\r\n    gap: var(--dl-space-space-oneandhalfunits);\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n}\r\n.home-hero-heading {\r\n    max-width: 800px;\r\n    text-align: center;\r\n}\r\n.home-hero-sub-heading {\r\n    font-size: 18px;\r\n    text-align: center;\r\n}\r\n.home-btn-group {\r\n    gap: var(--dl-space-space-oneandhalfunits);\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n}\r\n.home-features {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.home-features1 {\r\n    gap: var(--dl-space-space-threeunits);\r\n    width: 100%;\r\n    display: flex;\r\n    max-width: var(--dl-size-size-maxwidth);\r\n    align-items: center;\r\n    padding-top: var(--dl-space-space-fourunits);\r\n    padding-left: var(--dl-space-space-threeunits);\r\n    padding-right: var(--dl-space-space-threeunits);\r\n    flex-direction: column;\r\n    padding-bottom: var(--dl-space-space-fourunits);\r\n    justify-content: flex-start;\r\n}\r\n.home-container2 {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n}\r\n.home-features-heading {\r\n    margin-bottom: var(--dl-space-space-oneandhalfunits);\r\n}\r\n.home-features-sub-heading {\r\n    font-size: 18px;\r\n    text-align: center;\r\n}\r\n.home-container3 {\r\n    width: 100%;\r\n    grid-gap: var(--dl-grid-gap-space);\r\n    grid-template-columns: 1fr 1fr;\r\n}\r\n\r\n.absence-list .home-container3 {\r\n  display: grid;\r\n}\r\n\r\n.home-pricing {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    border: 2px dashed rgba(120, 120, 120, 0.4);\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.home-banner {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.home-banner-heading {\r\n    text-align: center;\r\n}\r\n.home-banner-sub-heading {\r\n    max-width: var(--dl-size-size-maxwidth);\r\n    margin-top: var(--dl-space-space-twounits);\r\n    text-align: center;\r\n    margin-bottom: var(--dl-space-space-twounits);\r\n}\r\n.home-faq {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.home-faq1 {\r\n    gap: var(--dl-space-space-twounits);\r\n    width: 100%;\r\n    display: flex;\r\n    max-width: var(--dl-size-size-maxwidth);\r\n    align-items: flex-start;\r\n    padding-top: var(--dl-space-space-fourunits);\r\n    padding-left: var(--dl-space-space-threeunits);\r\n    padding-right: var(--dl-space-space-threeunits);\r\n    flex-direction: row;\r\n    padding-bottom: var(--dl-space-space-fourunits);\r\n}\r\n.home-container4 {\r\n    display: flex;\r\n    max-width: 35%;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n}\r\n.home-text51 {\r\n    margin-bottom: var(--dl-space-space-oneandhalfunits);\r\n}\r\n.home-text52 {\r\n    text-align: left;\r\n}\r\n.home-container5 {\r\n    gap: var(--dl-space-space-oneandhalfunits);\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n}\r\n.home-footer {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.home-container6 {\r\n    gap: var(--dl-space-space-unit);\r\n    display: flex;\r\n    max-width: var(--dl-size-size-maxwidth);\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n}\r\n.home-nav1 {\r\n    flex: 0 0 auto;\r\n    border: 2px dashed rgba(120, 120, 120, 0.4);\r\n    display: flex;\r\n    margin-top: 0px;\r\n    align-items: center;\r\n    flex-direction: row;\r\n}\r\n.home-separator {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: 0px;\r\n    display: flex;\r\n    margin-top: var(--dl-space-space-twounits);\r\n    align-items: flex-start;\r\n    margin-left: 0px;\r\n    border-color: var(--dl-color-gray-900);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin-right: 0px;\r\n    margin-bottom: var(--dl-space-space-twounits);\r\n    flex-direction: row;\r\n    border-top-width: 0px;\r\n    border-left-width: 0px;\r\n    border-right-width: 0px;\r\n}\r\n.home-container7 {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n.home-icon-group1 {\r\n    border: 2px dashed rgba(120, 120, 120, 0.4);\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n@media (max-width: 991px) {\r\n    .home-hero1 {\r\n        flex-direction: column;\r\n    }\r\n    .home-container1 {\r\n        align-items: center;\r\n        margin-right: 0px;\r\n        margin-bottom: var(--dl-space-space-twounits);\r\n        padding-right: 0px;\r\n    }\r\n    .home-hero-heading {\r\n        text-align: center;\r\n    }\r\n    .home-text {\r\n        text-align: center;\r\n    }\r\n    .home-hero-sub-heading {\r\n        text-align: center;\r\n        padding-left: var(--dl-space-space-threeunits);\r\n        padding-right: var(--dl-space-space-threeunits);\r\n    }\r\n    .home-features-sub-heading {\r\n        text-align: center;\r\n        padding-left: var(--dl-space-space-threeunits);\r\n        padding-right: var(--dl-space-space-threeunits);\r\n    }\r\n    .home-banner-sub-heading {\r\n        max-width: 100%;\r\n    }\r\n    .home-text52 {\r\n        text-align: center;\r\n        padding-left: var(--dl-space-space-threeunits);\r\n        padding-right: var(--dl-space-space-threeunits);\r\n    }\r\n}\r\n@media (max-width: 767px) {\r\n    .home-navbar-interactive {\r\n        padding-left: var(--dl-space-space-twounits);\r\n        padding-right: var(--dl-space-space-twounits);\r\n    }\r\n    .home-desktop-menu {\r\n        display: none;\r\n    }\r\n    .home-burger-menu {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .home-nav12 {\r\n        margin-bottom: var(--dl-space-space-unit);\r\n    }\r\n    .home-nav22 {\r\n        margin-bottom: var(--dl-space-space-unit);\r\n    }\r\n    .home-nav32 {\r\n        margin-bottom: var(--dl-space-space-unit);\r\n    }\r\n    .home-nav42 {\r\n        margin-bottom: var(--dl-space-space-unit);\r\n    }\r\n    .home-hero1 {\r\n        padding-left: var(--dl-space-space-twounits);\r\n        padding-right: var(--dl-space-space-twounits);\r\n    }\r\n    .home-hero-sub-heading {\r\n        padding-left: var(--dl-space-space-unit);\r\n        padding-right: var(--dl-space-space-unit);\r\n    }\r\n    .home-features1 {\r\n        padding-left: var(--dl-space-space-twounits);\r\n        padding-right: var(--dl-space-space-twounits);\r\n    }\r\n    .home-features-sub-heading {\r\n        padding-left: var(--dl-space-space-unit);\r\n        padding-right: var(--dl-space-space-unit);\r\n    }\r\n    .home-container3 {\r\n        grid-template-columns: 1fr;\r\n    }\r\n    .home-banner1 {\r\n        padding-left: var(--dl-space-space-twounits);\r\n        padding-right: var(--dl-space-space-twounits);\r\n    }\r\n    .home-banner-sub-heading {\r\n        padding-left: var(--dl-space-space-unit);\r\n        padding-right: var(--dl-space-space-unit);\r\n    }\r\n    .home-faq1 {\r\n        flex-direction: column;\r\n    }\r\n    .home-container4 {\r\n        max-width: 100%;\r\n        align-self: center;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    .home-text52 {\r\n        padding-left: var(--dl-space-space-unit);\r\n        padding-right: var(--dl-space-space-unit);\r\n    }\r\n    .home-footer1 {\r\n        padding-left: var(--dl-space-space-twounits);\r\n        padding-right: var(--dl-space-space-twounits);\r\n    }\r\n    .home-separator {\r\n        margin-top: var(--dl-space-space-oneandhalfunits);\r\n        margin-left: 0px;\r\n        margin-right: 0px;\r\n        margin-bottom: var(--dl-space-space-oneandhalfunits);\r\n    }\r\n    .home-container7 {\r\n        align-items: center;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n    }\r\n    .home-text56 {\r\n        margin-bottom: var(--dl-space-space-oneandhalfunits);\r\n    }\r\n}\r\n@media (max-width: 479px) {\r\n    .home-navbar-interactive {\r\n        padding: var(--dl-space-space-unit);\r\n    }\r\n    .home-mobile-menu1 {\r\n        padding: 16px;\r\n    }\r\n    .home-hero1 {\r\n        padding-top: var(--dl-space-space-twounits);\r\n        padding-left: var(--dl-space-space-unit);\r\n        padding-right: var(--dl-space-space-unit);\r\n        padding-bottom: var(--dl-space-space-twounits);\r\n    }\r\n    .home-container1 {\r\n        margin-bottom: var(--dl-space-space-unit);\r\n    }\r\n    .home-btn-group {\r\n        flex-direction: column;\r\n    }\r\n    .home-features1 {\r\n        padding-top: var(--dl-space-space-twounits);\r\n        padding-left: var(--dl-space-space-unit);\r\n        padding-right: var(--dl-space-space-unit);\r\n        padding-bottom: var(--dl-space-space-twounits);\r\n    }\r\n    .home-banner1 {\r\n        padding-top: var(--dl-space-space-twounits);\r\n        padding-left: var(--dl-space-space-unit);\r\n        padding-right: var(--dl-space-space-unit);\r\n        padding-bottom: var(--dl-space-space-twounits);\r\n    }\r\n    .home-footer1 {\r\n        padding: var(--dl-space-space-unit);\r\n    }\r\n    .home-separator {\r\n        margin-top: var(--dl-space-space-oneandhalfunits);\r\n        margin-bottom: var(--dl-space-space-oneandhalfunits);\r\n    }\r\n    .home-container7 {\r\n        align-items: center;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n    }\r\n    .home-text56 {\r\n        text-align: center;\r\n        margin-bottom: var(--dl-space-space-oneandhalfunits);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
